<div [formGroup]="form" class="dynamic-form">
    <div class="form-group mb-3 row set-job">
        <div class="col-4">
            <label for="float-input" class=" label-control">{{ field['label'] }}</label>
        </div>
        <div class="col-8">
            <p-checkbox [binary]="true" inputId="binary" [formControlName]="field['name']"></p-checkbox>
        </div>
    </div>
</div>